import styled from "@emotion/styled";
import { ChangeEvent, FormEvent, useState } from "react";
import { AddUserButton } from "../../assets/icons/icons";
import theme from "../../theme";
import { SearchForm } from "../../components/common/SearchForm";
import { Button } from "../../components/common/Button";
import { SystemSetting } from "../../types/types";
import { useI18n } from "../../locales";

interface subHeaderProps {
  onClickBtn: (input: string) => void;
  openModal: () => void;
  systemSetting: SystemSetting | null;
}

const SubHeader: React.FC<subHeaderProps> = (props) => {
  const { onClickBtn, openModal, systemSetting } = props;
  const { t } = useI18n();
  const [input, setInput] = useState("");

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInput(event.currentTarget.value);
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onClickBtn(input);
  };

  return (
    <Wrapper>
      <SearchForm
        onSubmit={onSubmit}
        placeholder={t.manageUser.searchUser}
        onChange={onChange}
        inputValue={input}
        setInputValue={setInput}
        bottom="0"
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Button
          bgColor={theme.color.aquamarine_500}
          hoverColor={theme.color.aquamarine_600}
          onClick={openModal}
          height="40px"
          isDisabled={!systemSetting?.create}
        >
          <AddUserButtonContainer>
            <AddUserButton />
          </AddUserButtonContainer>
          {t.manageUser.addUser}
        </Button>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 92px;
  background: ${theme.color.neutral_50};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 23px;
`;

const AddUserButtonContainer = styled.div`
  margin-top: 3px;
`;
export default SubHeader;
